import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
    width: "100%",
  },
  isGreen: { color: "green" },
  isRed: { color: "red" },

  root: {
    display: "flex",
  },
  list: {
    flexGrow: 1,
    transition: theme.transitions.create(["all"], {
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
  listWithDrawer: {
    width: "80%",
  },
  drawerPaper: {
    zIndex: 100,
    width: "20%",
  },
}));
